/* jshint -W117, -W030, -W068, -W074 */
(function () {
    'use strict';

    var clrSso = {
        q: null,
        interval: null,
        window: window,
        domain: document.domain,
        setToken: function (newToken) {
            this.window.localStorage.setItem('token', newToken);
        },
        getToken: function () {
            var self = this,
                retries = 5;
            if (this.q) {
                return this.q(function (resolve, reject) {
                    var scopeWindow = self.window;
                    var scopeLocalStorage = scopeWindow.localStorage;
                    var interval = self.interval;
                    var retryFunc = interval(function () {
                        var token = scopeLocalStorage.getItem('token');
                        if (token) {
                            resolve(token);
                            interval.cancel(retryFunc);
                            retryFunc = undefined;
                        } else if (retries <= 0) {
                            reject('Unable to get auth token.');
                            interval.cancel(retryFunc);
                            retryFunc = undefined;
                        }
                    }, 300, 5);
                });
            } else {
                return this.window.localStorage.getItem('token');
            }
        },

        removeToken: function () {
            return this.window.localStorage.removeItem('token');
        },

        redirectCallbackUrl: function () {
            if (this.requesterUrl) {
                return this.requesterUrl;
            } else {
                return this.window.location.href;
            }
        },

        loginRedirectUrl: function (params) {
            params = params || {};
            return this.redirectUrl + this.loginPage + '?' + this.serialize(params) + '&' + 'SSORequester=' +
                encodeURIComponent(this.redirectCallbackUrl());
        },

        login: function (params) {
            var storedParams = this.window.localStorage.getItem('paramsAuth');
            if (storedParams) {
                params = JSON.parse(storedParams);
            }
            this.window.location = this.loginRedirectUrl(params);
        },

        logout: function (requesterUrl) {
            if (requesterUrl) {
                this.requesterUrl = requesterUrl;
            }
            this.removeToken();
            this.login();
        },

        startup: function (options) {
            options = options || {};
            var callback = options.callback || undefined,
                params = options.params || {};

            this.requesterUrl = options.requesterUrl || false;
            this.redirectUrl = options.validationUrl || 'https://access.conversantmedia.com';
            this.loginPage = options.loginPage || '/#/login';
            this.ssoPage = options.ssoPage || '/sso.html';

            if (params) {
                this.window.localStorage.setItem('paramsAuth', JSON.stringify(params));
            }

            if (this.domain !== this.extractDomain(this.redirectUrl)) {
                this.buildIframe(params, callback);
            }
        },

        buildIframe: function (params, callback) {
            var self = this;
            var iframe = this.window.document.createElement('iframe'),
                listener = this.window.addEventListener || this.window.attachEvent;

            iframe.src = this.redirectUrl + this.ssoPage;
            iframe.sandbox = 'allow-same-origin allow-scripts';
            iframe.width = iframe.height = iframe.frameborder = iframe.frameBorder = 0;
            iframe.style.position = 'absolute';
            this.window.document.body.appendChild(iframe);
            listener('message', function (e) {
                console.log('message received ', e);
                if (e.source === iframe.contentWindow.window) {
                    var token = e.data;
                    if (token) {
                        self.setToken(token, false);
                        if (typeof callback === 'function') {
                            callback(token);
                        }
                    } else {
                        self.removeToken();
                        self.login(params);
                    }
                }
            }, false);
            iframe.onload = function () {
                iframe.contentWindow.postMessage('get-token', iframe.src);
            };
        },

        extractDomain: function extractDomain(url) {
            var domain;
            if (!url) {
                return url;
            }
            if (url.indexOf('://') > -1) {
                domain = url.split('/')[2];
            } else {
                domain = url.split('/')[0];
            }
            domain = domain.split(':')[0];
            return domain;
        },

        init: function () {
            if (typeof angular !== 'undefined') {
                angular
                    .module('clr.sso', [])
                    .factory('clrSso', ['$window', '$q', '$interval', '$httpParamSerializerJQLike',
                        function ($window, $q, $interval, $httpParamSerializerJQLike) {
                            clrSso.q = $q;
                            clrSso.interval = $interval;
                            clrSso.window = $window;
                            clrSso.serialize = $httpParamSerializerJQLike;
                            return clrSso;
                        }]);
            } else {
                this.serialize = $.param;
            }
        }
    };

    if (typeof module !== 'undefined' && typeof angular === 'undefined') {
        module.exports = clrSso;
    } else {
        clrSso.init();
    }
}).call(this);



//////////////////
// WEBPACK FOOTER
// ./~/clarity-ui-sso/src/clr-sso.js
// module id = 222
// module chunks = 0